module.exports = __webpack_public_path__ + "static/media/10.cc973c87.svg";